import { render } from "./EmergencyContactFields.vue?vue&type=template&id=b6e1a63c&scoped=true"
import script from "./EmergencyContactFields.vue?vue&type=script&lang=js"
export * from "./EmergencyContactFields.vue?vue&type=script&lang=js"

import "./EmergencyContactFields.vue?vue&type=style&index=0&id=b6e1a63c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e1a63c"]])

export default __exports__